import { CompassCardUI } from '@scale/compass-ui/types';
import {
  TaskResponseCardShared,
  type TaskResponseSchemaType,
  type TaskResponseContext,
  TASK_RESPONSE,
} from '@scale/genai-compass-shared/cards/task_response';
import { faFileImport } from '@fortawesome/pro-solid-svg-icons';
import TaskResponseCardComponent from './TaskResponseCardComponent';

const defaultContext: TaskResponseContext = {
  cardType: TASK_RESPONSE,
  columnName: 'Latest Response',
  jsonataExpression: `(
  /* Passing in $ as the JSONata expression returns the entire response object*/
  $
)`,
  flatten: false,
};

export const TaskResponseCardInfo: CompassCardUI<TaskResponseSchemaType> = {
  ...TaskResponseCardShared,
  title: 'Import Latest Response',
  icon: 'file-import',
  toolTip: 'Add the most recent response to the task',
  defaultContext,
  isAdvanced: true,
  legacyComponent: TaskResponseCardComponent,
  button: {
    icon: faFileImport,
  },
};
